import {
  createDesignerCommonConfig,
  deleteDesignerCommonConfig,
  listDesignerCommonConfigSettings,
  updateDesignerCommonConfig
} from "../../designer-common-config-actions";
import { runDesignerPreview, saveDesignerScreen } from "../../designer-project-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const projectTools: ToolHandlerGroup = {
  sync: {
    ui_project_list_common_settings: (input) => listDesignerCommonConfigSettings(getSdInstance(), input)
  },
  async: {
    ui_common_save_screen: async () => saveDesignerScreen(getSdInstance()),
    ui_run_preview: async () => runDesignerPreview(getSdInstance()),
    ui_project_create_common_setting: async (input) => createDesignerCommonConfig(getSdInstance(), input),
    ui_project_update_common_setting: async (input) => updateDesignerCommonConfig(getSdInstance(), input),
    ui_project_delete_common_setting: async (input) => deleteDesignerCommonConfig(getSdInstance(), input),
    ui_common_reload_project: async () => {
      const sd = getSdInstance();
      await sd.projectProvider.openProject(true);
      await new Promise((resolve) => setTimeout(resolve, 500));
      return { success: true, message: "Reloaded project data (languages, settings) from backend" };
    }
  }
};
